import { AfterViewInit, Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { AuthService } from './shared/auth.service';
import { MenuItem } from 'primeng/api';
import { environment } from '../environments/environment';
@Component({
  selector: 'pcc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  userIsAuthenticated = false;
  winningsUser = false;
  displaySidebar: boolean = true;
  displayHelpPanel: boolean = false;
  mobileDevice = window.innerWidth > environment.mobileMaxWidth ? false : true;
  breadCrumbItems: MenuItem[] = [];
  routePath: string | undefined;
  helpContent: string;
  private subs: Subscription[] = [];

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit() {
    // user authentication
    this.subs.push(this.authService.authStatusListener.subscribe(authStatus => {
      if (authStatus === 'success') {
        this.userIsAuthenticated = true;
        this.winningsUser = this.authService.isWinnings;
        this.displaySidebar = true;
      } else {
        this.userIsAuthenticated = false;
        this.winningsUser = false;
      }
    }));

    // get current route path
    this.subs.push(this.router.events.pipe(
      filter(evt => evt instanceof NavigationEnd),
    ).subscribe(() => {
      this.routePath = this.router.url;
      this.helpContent = 'This is the help content based upon the current route: ' + this.routePath;
    }));

  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  ngAfterViewInit(): void {
  }

  toggleHelp() {
    this.displayHelpPanel = !this.displayHelpPanel;
  }

  closeHelp() {
    this.displayHelpPanel = false;
  }

  @HostListener('click', ['$event'])
  click(event: PointerEvent) {
    this.authService.updateActivity(); // update authservice activity to delay autologout
    // optionally use the event for other tracking if required
  }

  @HostListener('window:resize', ['$event'])
  windowResize(event: Event) {
    this.mobileDevice = window.innerWidth > environment.mobileMaxWidth ? false : true;
  }
}
